import { TOGGLE_HELP } from "constants/actions";
import { Map } from "immutable";
const INITIAL_STATE = new Map({
    value: false
});

export default (state=INITIAL_STATE, {type, isToggle}) => {
    switch(type) {
    case TOGGLE_HELP.TOGGLE_HELP_INFO:
        return state.set("value", isToggle);
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};